export default __webpack_public_path__ + "static/media/CEWE_logo_705.d73de980.jpg";